import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { resolveUrl } from './util';
import { getMimeType } from './mimes';
import { isDataUrl, makeDataUrl, resourceToDataURL } from './dataurl';
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;

function toRegex(url) {
  // eslint-disable-next-line no-useless-escape
  var escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
  return new RegExp("(url\\(['\"]?)(".concat(escaped, ")(['\"]?\\))"), 'g');
}

export function parseURLs(cssText) {
  var urls = [];
  cssText.replace(URL_REGEX, function (raw, quotation, url) {
    urls.push(url);
    return raw;
  });
  return urls.filter(function (url) {
    return !isDataUrl(url);
  });
}
export function embed(_x, _x2, _x3, _x4, _x5) {
  return _embed.apply(this, arguments);
}

function _embed() {
  _embed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    var resolvedURL, contentType, dataURL, content;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            resolvedURL = baseURL ? resolveUrl(resourceURL, baseURL) : resourceURL;
            contentType = getMimeType(resourceURL);

            if (!getContentFromUrl) {
              _context.next = 10;
              break;
            }

            _context.next = 6;
            return getContentFromUrl(resolvedURL);

          case 6:
            content = _context.sent;
            dataURL = makeDataUrl(content, contentType);
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return resourceToDataURL(resolvedURL, contentType, options);

          case 12:
            dataURL = _context.sent;

          case 13:
            return _context.abrupt("return", cssText.replace(toRegex(resourceURL), "$1".concat(dataURL, "$3")));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);

          case 18:
            return _context.abrupt("return", cssText);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));
  return _embed.apply(this, arguments);
}

function filterPreferredFontFormat(str, _ref) {
  var preferredFontFormat = _ref.preferredFontFormat;
  return !preferredFontFormat ? str : str.replace(FONT_SRC_REGEX, function (match) {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      var _ref2 = URL_WITH_FORMAT_REGEX.exec(match) || [],
          _ref3 = _slicedToArray(_ref2, 3),
          src = _ref3[0],
          format = _ref3[2];

      if (!format) {
        return '';
      }

      if (format === preferredFontFormat) {
        return "src: ".concat(src, ";");
      }
    }
  });
}

export function shouldEmbed(url) {
  return url.search(URL_REGEX) !== -1;
}
export function embedResources(_x6, _x7, _x8) {
  return _embedResources.apply(this, arguments);
}

function _embedResources() {
  _embedResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cssText, baseUrl, options) {
    var filteredCSSText, urls;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (shouldEmbed(cssText)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", cssText);

          case 2:
            filteredCSSText = filterPreferredFontFormat(cssText, options);
            urls = parseURLs(filteredCSSText);
            return _context2.abrupt("return", urls.reduce(function (deferred, url) {
              return deferred.then(function (css) {
                return embed(css, url, baseUrl, options);
              });
            }, Promise.resolve(filteredCSSText)));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _embedResources.apply(this, arguments);
}